import * as rmd from 'material-ui';
import React from "react";

class MBPicker extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            enabled: !_.isEmpty(props.moreButtonUrl) && !_.isEmpty(props.moreButtonLabel),
            label: props.moreButtonLabel || "",
            url: props.moreButtonUrl || ""
        }
    }

    onChange = (key, e) => {

        this.setState(_.fromPairs([[key, e.target.value]]));

    }

    handleOnBlur = (e) => {
        let {enabled, label, url} = this.state;
        if (enabled && !_.isEmpty(label) && !_.isEmpty(url)) {
            this.props.onChange({'moreButtonUrl': url, 'moreButtonLabel': label});
        }
    }
    handleEnableToggle = (e, value) => {
        this.setState({enabled: value})
        if (!value) {
            this.props.onChange({'moreButtonUrl': null, 'moreButtonLabel': null});
            this.setState({url: "", label: ""})
        }
    }
    render() {
        let {enabled, label, url} = this.state;
        return (
            <div >
                <rmd.Toggle
                    label="Display More Button"
                    onToggle={this.handleEnableToggle}
                    toggled={this.state.enabled} />

                {
                    enabled && <rmd.TextField
                                    value={label || ""}
                                    onChange={this.onChange.bind(this, 'label')}
                                    onBlur={this.handleOnBlur}
                                    hintText="Enter Label Text"
                                    floatingLabelText="Label" />
                }
                {
                    enabled && <rmd.TextField
                                    value={url || ""}
                                    onChange={this.onChange.bind(this, 'url')}
                                    onBlur={this.handleOnBlur}
                                    hintText="http://"
                                    floatingLabelText="Url" />
                }
            </div>
        );
    }
}

export default MBPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/MoreButtonPicker.js
 **/